import { Injectable } from '@angular/core';
import amplitude, { AmplitudeClient } from 'amplitude-js';
import { AMPLITUDE_EVENT } from '@shared/types/enums/amplitude';
import { APP_CONFIG } from '@shared/config/app.config';

amplitude.getInstance().init(APP_CONFIG.amplitude.clientId);

@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  private readonly amplitudeClient: AmplitudeClient;
  private readonly APP_KEY = APP_CONFIG.amplitude.appKey;
  private customerProperties: { rppUserId: string | undefined; country: string | undefined } | undefined;

  constructor() {
    this.amplitudeClient = amplitude.getInstance();
  }

  setUserId(id: string | undefined) {
    if (id) {
      this.amplitudeClient.setUserId(id);
    }
  }

  setCustomerProperties(customerProperties: { rppUserId: string | undefined; country: string | undefined }) {
    this.customerProperties = customerProperties;
  }

  setUserProperties(properties: { roles?: string[]; country: string }) {
    this.amplitudeClient.setUserProperties(properties);
  }

  logEvent<T>(event: AMPLITUDE_EVENT, eventProperties?: T) {
    if (APP_CONFIG.production) {
      this.amplitudeClient.logEvent(`${this.APP_KEY}_${event}`, { ...this.customerProperties, ...eventProperties });
    } else {
      // console.log(
      //   `[TESTING] log event ${event} by user ${this.amplitudeClient.getUserId()} with customer properties`,
      //   this.customerProperties,
      //   ` and event properties`,
      //   eventProperties
      // );
    }
  }
}
